// Data sevice
import axios from 'axios'
import authHeader from './auth-header'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const API_URL = process.env.VUE_APP_API_URL;

class FilesService {

    index() {
        return axios.get(API_URL + 'access-logs', { headers: authHeader() })
    }
    show(id) {
        return axios.get(API_URL + 'access-logs/' + id, { headers: authHeader() })
    }
    store(resource) {
        return axios.post(API_URL + 'access-logs', resource, { headers: authHeader() })
    }
    update(resource) {
        return axios.put(API_URL + 'access-logs/' + resource.id, resource, { headers: authHeader() })
    }
    delete(resource) {
        return axios.delete(API_URL + 'delete-file/' + resource._id, { headers: authHeader() })
    }
}

export default new FilesService()